import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import api from './api/axiosInstance';
import base_url from './api/Config';
import TopBar from './component/TopBar';

const Bankdetail = () => {
  const [ifscCode, setIfscCode] = useState('');
  const [accountNumber, setAccountNumber] = useState('');
  const [bankName, setBankName] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [whyModal, setWhyModal] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const applicationId = new URLSearchParams(location.search).get('applicationId');
  const customerId    = new URLSearchParams(location.search).get('customerId');

  const handleIfscChange = async (e) => {
    const value = e.target.value.toUpperCase();
    setIfscCode(value);
    if (value.length === 11) {
      try {
        const res = await axios.get(`https://ifsc.razorpay.com/${value}`);
        setBankName(res.data.BANK || '');
      } catch {
        setBankName('');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isChecked) { alert('Please agree to the terms before proceeding.'); return; }
    setIsLoading(true);
    try {
      await api.post(
        `${base_url}/api/account/updateAddAccount?applicationId=${applicationId}&customerId=${customerId}`,
        { accountNumber, ifscCode, bankName }
      );
      navigate(`/Employmentdetails?applicationId=${applicationId}&customerId=${customerId}`);
    } catch {
      alert('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="app-page">
      <TopBar title="Bank Details" backPath={`/CreditCheck?applicationId=${applicationId}&customerId=${customerId}`} />
      {isLoading && <div className="loader-overlay"><div className="spinner-border text-light" /></div>}

      <div className="app-content">
        <form onSubmit={handleSubmit}>
          <div className="app-card">
            <p className="section-title">Bank Account Information</p>

            <div className="field-group">
              <label className="field-label">IFSC Code <span className="field-star">*</span></label>
              <input className="field-input" value={ifscCode} onChange={handleIfscChange} maxLength={11} style={{ textTransform: 'uppercase' }} required />
            </div>

            <div className="field-group">
              <label className="field-label">Bank Name</label>
              <input className="field-input" value={bankName} readOnly style={{ background: '#f5f5f5' }} />
            </div>

            <div className="field-group">
              <label className="field-label">Account Number <span className="field-star">*</span></label>
              <input className="field-input" type="tel" value={accountNumber} onChange={e => setAccountNumber(e.target.value)} pattern="[0-9]*" required />
            </div>
          </div>

          <div className="app-card">
            <div className="check-row">
              <input type="checkbox" checked={isChecked} onChange={e => setIsChecked(e.target.checked)} required />
              <label>I confirm this account belongs to me and agree to disburse the loan amount to this account.</label>
            </div>
            <button type="button" onClick={() => setWhyModal(true)} style={{ background: 'none', border: 'none', color: '#1d2e77', fontSize: 13, fontWeight: 600, padding: 0, cursor: 'pointer' }}>
              Why do we need your account number?
            </button>
          </div>

          <button type="submit" className="btn-primary-app" disabled={isLoading}>
            {isLoading ? 'Saving...' : 'Proceed'}
          </button>
        </form>
      </div>

      <Modal show={whyModal} onHide={() => setWhyModal(false)} centered>
        <Modal.Header closeButton><Modal.Title>Why we need this?</Modal.Title></Modal.Header>
        <Modal.Body>
          Account numbers are collected to facilitate payment processing, verify banking details, prevent fraud, enable direct deposits, and link customers to their financial activities.
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={() => setWhyModal(false)}>Okay</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Bankdetail;
